import alertActions from '../actions/alert.actions';

const alertReducer = (state, action) => {
  switch (action.type) {
    case alertActions.SUCCESS:
      return Object.assign({}, state, { successMessage: action.message });
    case alertActions.ERROR:
      return Object.assign({}, state, { errorMessage: action.message });
    case alertActions.CLEAR:
      return Object.assign({}, state, { successMessage: '', errorMessage: '' });
    default:
      return state;
  }
};

export default alertReducer;
